import { dataMember, required, typedArray } from 'santee-dcts';
import {ExternalUserEQueriesFilter} from '../../../e-queries/models/external-user-e-queries-filter';

export class InvestigatorEQueryFilterItem extends ExternalUserEQueriesFilter { }

export class InvestigatorEQueryFilterItemsReadModel {
    @dataMember()
    @required()
    @typedArray(InvestigatorEQueryFilterItem)
    public filterItems: InvestigatorEQueryFilterItem[];
}
